module.exports = __webpack_public_path__ + "static/media/1004894.5aa359f7.png";